import styled from "styled-components";

import { TAB_BAR } from "../../constants/tabBar";
import { fontSizes } from "../../shared/styles/typography";
import { tokens } from "../../theme/tokens";

const BP = tokens.layout.mobileFirstExpandPx;

export const PageBody = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const EmptyState = styled.div`
  text-align: center;
  padding: 48px 20px;
  color: ${TAB_BAR.secondary};

  svg {
    margin-bottom: 16px;
    opacity: 0.5;
  }

  h2 {
    font-size: ${fontSizes.xl}px;
    font-weight: var(--font-weight-semibold);
    color: var(--color-text-title);
    margin-bottom: 8px;
  }

  p {
    font-size: ${fontSizes.sm}px;
    line-height: 1.5;
  }
`;

export const ListWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  @media (min-width: ${BP}px) {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  @media (min-width: 1200px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
`;
